module.exports = __webpack_public_path__ + "img/home-active.4437b065.png";